import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { hasSetupSelector } from '../selectors/appSelectors';
import RouteWithSubRoutes from '../components/RouteWithSubRoutes/RouteWithSubRoutes';

const mapStateToProps = createStructuredSelector({ hasSetup: hasSetupSelector });

export default connect(mapStateToProps)(RouteWithSubRoutes);
